import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private isMobile = new BehaviorSubject<boolean>(this.checkIfMobile());
  private isPortrait = new BehaviorSubject<boolean>(this.checkIfPortrait());

  constructor() {
    // Listen for resize events
    fromEvent(window, 'resize').subscribe(() => {
      this.isMobile.next(this.checkIfMobile());
      this.isPortrait.next(this.checkIfPortrait());
    });

    // Listen for orientation changes
    fromEvent(window, 'orientationchange').subscribe(() => {
      this.isPortrait.next(this.checkIfPortrait());
    });
  }

  private checkIfMobile(): boolean {
    return window.innerWidth <= 768;
  }

  private checkIfPortrait(): boolean {
    return window.innerHeight > window.innerWidth;
  }

  getIsMobile() {
    return this.isMobile.asObservable();
  }

  getIsPortrait() {
    return this.isPortrait.asObservable();
  }
}